export enum GoalLevel {
   'Organization',
   'Business Unit',
   'Department',
}
